import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "grid grid-cols-1 place-items-center mt-52 m-4" }
const _hoisted_3 = { class: "bg-white p-4 text-center rounded" }
const _hoisted_4 = { class: "my-4" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "my-4" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "my-4" }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = { class: "my-auto font-medium text-base" }
const _hoisted_11 = { class: "relative w-full" }
const _hoisted_12 = { class: "absolute -top-10 -right-4" }
const _hoisted_13 = { class: "text-center text-xl font-semibold uppercase m-0" }

import { AxiosInstance } from "axios";
import { inject, onMounted, ref } from "vue";
import { XCircleIcon } from "@heroicons/vue/solid";
import Navbar from "@/components/tools/Navbar.vue";
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import { useStore } from "vuex";
interface IStreamConfig {
  id?: number;
  operatorId: string;
  name: string;
  value: string;
  description?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'stream-config',
  setup(__props) {

const store = useStore()
const axios = inject("$axios") as AxiosInstance;
const configData = ref<IStreamConfig>({
  id: 0,
  operatorId: store.state.selectedOperator.operatorId,
  name: "",
  value: "",
  // description: "",
});
const updateDialog = ref({
  open: false,
  message: "",
});


let isCreate = true
const onSubmit = async () => {
  let response
  configData.value.value = configData.value.value.toString()
  try {
    if (isCreate) {
      delete configData.value.id
      response = await axios
        .post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/stream/api/internal/configs`,
          configData.value
        )
    } else {
      response = await axios
        .put(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/stream/api/internal/configs`,
          configData.value
        )
    }
  } catch (e) {
    updateDialog.value = {
      open: true,
      message:
        `Error: ${e}`,
    };
  }
  if (response) {
    updateDialog.value = {
      open: true,
      message: isCreate ? "Create Success" : "Update Success",
    };
  } else {
    updateDialog.value = {
      open: true,
      message: isCreate ? "Create Fail" : "Update Fail",
    };
  }
};
onMounted(async () => {
  await axios
    .post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/stream/api/internal/configs/list`, {
      operatorId: store.state.selectedOperator.operatorId,
    }
    )
    .then((response) => {
      if (response.data.data.lenght !== 0) {
        configData.value.id = response.data.data[0].id
        configData.value.name = response.data.data[0].name
        configData.value.value = response.data.data[0].value
        configData.value.description = response.data.data[0].description
        isCreate = false
      }
    }
    );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Navbar, {
        title: _ctx.$t('messages.stream.streamConfig')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("messages.stream.streamer.name")), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((configData.value.name) = $event)),
              type: "text",
              class: "rounded w-full"
            }, null, 512), [
              [_vModelText, configData.value.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("messages.stream.streamer.description")), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((configData.value.description) = $event)),
              type: "text",
              class: "rounded w-full"
            }, null, 512), [
              [_vModelText, configData.value.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("messages.stream.accumulateDeposit")), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((configData.value.value) = $event)),
              type: "number",
              class: "rounded w-full"
            }, null, 512), [
              [_vModelText, configData.value.value]
            ])
          ]),
          _createElementVNode("button", {
            class: "bg-blue-400 px-7 py-2 text-white rounded",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (onSubmit()))
          }, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("messages.loyaltyConfig.save")), 1)
          ])
        ])
      ])
    ]),
    _createVNode(DialogComponent, {
      isOpen: updateDialog.value.open
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(XCircleIcon), {
              class: "ml-auto w-8 h-8 cursor-pointer",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (updateDialog.value.open = false))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_13, _toDisplayString(updateDialog.value.message), 1)
      ]),
      _: 1
    }, 8, ["isOpen"])
  ], 64))
}
}

})